module.exports = __webpack_public_path__ + "static/media/OcklloLogo.61ba99ed.svg";